import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';

import { renderField } from 'Common/FormHelper';
import { IMPORT_SITE_FORM_NAME } from 'Common/FormEnum';

class ImportSiteForm extends Component {
  onChange = e => {
    if (e.target.value.length > 0) {
      this.props.clearImportSiteErrors();
    }
  };

  render() {
    const { handleSubmit } = this.props;

    return (
      <form onSubmit={handleSubmit}>
        <div>
          <label>Import File</label>
          <Field
            name="import_file"
            component={renderField}
            type="file"
            onChange={this.onChange}
          />
        </div>
      </form>
    );
  }
}

export default reduxForm({
  form: IMPORT_SITE_FORM_NAME,
})(ImportSiteForm);



// WEBPACK FOOTER //
// ./src/pages/importsite/components/ImportSiteForm.js